'use strict';

// Legacy - used by front-end non-API calls

// Global/generic error handler for Ajax requests
var ParseAPI = function(query, err, res) {
    var r = null,
        exception = null;
    try {
        r = JSON.parse(res.text);
    } catch (exception) {
        if (typeof Raven !== 'undefined' && Raven) {
            var err_str = (err && err.response) ? `${err.response.statusCode}: ${err.response.statusText}` : '<no err>';
            var text_str = res ? res.text : '<no res>';
            Raven.captureException(exception, {
                extra: {
                    query: query,
                    err: err_str,
                    res: text_str,
            }});
        }
        if (typeof alert !== 'undefined') {
            // alert('An error occurred; this has been reported. Please try reloading the page.');
        } else {
            console.log('An error occurred; this has been reported. Please try reloading the page.');
            console.log(err_str, res.text);
        }
        return null;
    }
    return r;
};

module.exports = {
    ParseAPI:          ParseAPI,
};



// WEBPACK FOOTER //
// ./src/global/frontend-parse-api.js